import './SpecificationDocument.scss';
import { useQuery } from '@apollo/client';
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import AUTOCOMPLETE_PRODUCT_LABELS from 'api/queries/AUTOCOMPLETE_PRODUCT_LABELS';
import GET_MODEL_SPECIFICATION from 'api/queries/GET_MODEL_SPECIFICATION';
import Loader from 'atoms/Loader/Loader';
import Dashboard from 'layout/templates/Dashboard/Dashboard';
import DocumentView from './DocumentView';
function SpecificationDocument({ includeComponents = false }) {
    const { modelSpecificationId } = useParams();
    const { data, loading, error } = useQuery(GET_MODEL_SPECIFICATION, {
        variables: { modelSpecificationId },
    });
    const { data: productLabelsData, loading: productLabelsLoading } = useQuery(AUTOCOMPLETE_PRODUCT_LABELS);
    if (error || (data === null || data === void 0 ? void 0 : data.node) === null) {
        return React.createElement(Navigate, { to: "/specifications", replace: true });
    }
    if (loading || productLabelsLoading) {
        return (React.createElement(Dashboard, null,
            React.createElement(Loader, null)));
    }
    return (React.createElement(DocumentView, { data: data, productLabels: productLabelsData, includeComponents: includeComponents }));
}
export default SpecificationDocument;
